module.exports = __webpack_public_path__ + "img/symbol_0.96343c65.png";